import Swal from 'sweetalert2';

const showErrorAlert = (error) => {
    const errorMessage = error.response?.data?.error || "Something went wrong!";
    Swal.fire({
        position: "top",
        icon: "error",
        title: "Error",
        text: errorMessage,
    });
};

const showErrorAlerts = (error) => {
  
    Swal.fire({
        position: "top",
        icon: "error",
        title: "Error",
        text: error,
    });
};

const showsuccessAlert = (message) => {
    
    Swal.fire({
        position: "top",
        icon: "success",
        title: "Success",
        text: message,
    });
};

export  {showErrorAlert,showsuccessAlert,showErrorAlerts};
